module.exports = __webpack_public_path__ + "img/to.79354e72.svg";